import React from 'react'
import { connect } from 'react-redux'

const PreloadBackgrounds = props => (
  <div style={{ visibility: 'hidden', position: 'absolute' }}>
    {props.backgrounds.map((item, idx) => (
      <div key={idx} style={{ backgroundImage: `url(${item})` }}></div>
    ))}
  </div>
)

export default connect(
  (state, props) => {
    const home = state.home
    const chapters = state.chapters.chapters.byId
    const chaptersIds = state.chapters.chapters.allIds

    const backgrounds = chaptersIds.reduce((acc, id) => {
      return acc.concat(chapters[id].background)
    }, [])

    backgrounds.push(home.background)

    return { backgrounds }
  },
  () => ({})
)(PreloadBackgrounds)
